<template>
  <div class="loginWrap">
    <img src="../../assets/imgs/login/logo.png" alt="" class="logoImg">
    <!-- 输入框 -->
    <div class="loginCon">
      <van-field v-model="loginForm.member" placeholder="请输入手机号" clearable>
        <div slot="left-icon">
          <img src="../../assets/imgs/login/phone.png" alt class="loginIcon" />
        </div>
      </van-field>
      <van-field v-model="loginForm.password" placeholder="请输入密码" :type="psdtype==true?'password':'text'" clearable>
        <div slot="left-icon">
          <img src="../../assets/imgs/login/psd.png" alt class="loginIcon" />
        </div>
        <div slot="right-icon" @click="psdtype=!psdtype">
          <van-icon name="closed-eye" v-if="psdtype==true" />
          <van-icon name="eye-o" v-if="!psdtype" />
        </div>
      </van-field>
      <div class="loginOther">
        <van-checkbox v-model="checked" checked-color="#1989fa" @change="rememberPsd" shape="square" icon-size="12px">
          记住密码</van-checkbox>
        <!-- <div @click="$router.push('forgetPsd')">忘记密码</div> -->
      </div>
      <van-button class="loginBtn" @click="toLogin">登录</van-button>
      <!-- <p class="toReg" @click="$router.push('register')">
        还没有账号?点击
        <span>这里</span>立即注册
      </p> -->
    </div>
  </div>
</template>
<script>
  import { login } from "@/api/login.js";
  export default {
    data() {
      return {
        psdtype: true,
        active: 0,
        loginForm: {
          member: "",
          password: ""
        },
        checked: false
      };
    },
    created() {
      //    获取记住的密码和账号
      let localPhone = localStorage.getItem("userPhone");
      let localPsd = localStorage.getItem("userPsd");
      let localChecked = localStorage.getItem("checked");
      if (localPhone && localPsd && localChecked) {
        this.loginForm.member = localPhone;
        this.loginForm.password = localPsd;
        this.checked = localChecked;
      }
    },
    methods: {
      rememberPsd() {
        if (this.checked == true) {
          localStorage.setItem("userPhone", this.loginForm.member);
          localStorage.setItem("userPsd", this.loginForm.password);
          localStorage.setItem("checked", this.checked);
        } else {
          localStorage.removeItem("userPhone");
          localStorage.removeItem("userPsd");
          localStorage.removeItem("checked");
        }
      },
      toLogin() {
        if (!this.loginForm.member || !this.loginForm.password) {
          this.$toast("请填写手机号或登录密码!");
          return;
        }
        login(this.loginForm).then(res => {
          this.$router.push("home");
          localStorage.setItem("userPhone", this.loginForm.member);
          localStorage.setItem("userToken", res.token);
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .logoImg {
    display: block;
    margin: 0 auto;
    width: 210px;
    height: 150px;
  }

  .loginWrap {
    height: 100vh;
    background: url("../../assets/imgs/login/loginBg.png") 0 0;
    background-size: 100%;
    box-sizing: border-box;
    padding-top: 50px;

    .loginCon {
      width: 295px;
      margin: 0 auto;
    }

    .loginIcon {
      width: 17.5px;
      height: 21px;
    }

    /deep/ .van-field__left-icon {
      margin-right: 13.5px;
    }

    .van-field {
      margin: 29px auto 0;
      border-radius: 20px;
      height: 44px;

      .van-field__button {
        .van-button {
          color: #187441;
          border: 0 none;
          background: transparent;
          font-size: 15px;
        }
      }
    }

    .van-cell:not(:last-child)::after {
      border-color: #b8b8b8;
      left: 40px;
    }

    /deep/.van-field__control {
      &::placeholder {
        color: #b8b8b8;
      }
    }

    .loginOther {
      width: 220px;
      margin: 6px auto 35.5px;
      display: flex;
      justify-content: space-between;
      color: #b8b8b8;
      font-size: 11px;

      /deep/ .van-checkbox__label {
        color: #b8b8b8;
      }
    }

    .loginBtn {
      width: 317.5px;
      display: block;
      height: 44px;
      background: linear-gradient(#008FFF, #007EFF);
      font-size: 15px;
      font-weight: bold;
      margin: 50px auto 0;
      border-radius: 20px;
      color: #fff;
      line-height: 44px;
    }
  }

  /deep/ .van-checkbox__icon .van-icon {
    border: 0.02667rem solid #ccc;
  }

  .toReg {
    text-align: center;
    color: #b8b8b8;
    font-size: 13px;

    span {
      color: #FA4A42;
    }
  }

</style>